module.exports = __webpack_public_path__ + "img/illustrations-calendar.94028e82.svg";